import { render, staticRenderFns } from "./noticeItem.vue?vue&type=template&id=716621c8"
import script from "./noticeItem.vue?vue&type=script&lang=js"
export * from "./noticeItem.vue?vue&type=script&lang=js"
import style0 from "./noticeItem.vue?vue&type=style&index=0&id=716621c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports